__turbopack_context__.v({
  "load_more_button": "ShowsLandingResults-module-scss-module__OMgm4q__load_more_button",
  "loading_indicator": "ShowsLandingResults-module-scss-module__OMgm4q__loading_indicator",
  "results": "ShowsLandingResults-module-scss-module__OMgm4q__results",
  "results_text_header": "ShowsLandingResults-module-scss-module__OMgm4q__results_text_header",
  "results_text_small": "ShowsLandingResults-module-scss-module__OMgm4q__results_text_small",
});
